module.exports = (__webpack_require__(1))(28);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/FolderModel.js from dll-reference girder_lib
// module id = 14
// module chunks = 0